var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoProceso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_339",
    "data-name": "Grupo 339",
    transform: "translate(-495 -698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_104",
    "data-name": "Trazado 104",
    transform: "translate(495 698)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.143,0H42.857A7.143,7.143,0,0,1,50,7.143V42.857A7.143,7.143,0,0,1,42.857,50H7.143A7.143,7.143,0,0,1,0,42.857V7.143A7.143,7.143,0,0,1,7.143,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.142860412597656 3 C 4.858478546142578 3 3 4.858478546142578 3 7.142860412597656 L 3 42.85713958740234 C 3 45.14152145385742 4.858478546142578 47 7.142860412597656 47 L 42.85713958740234 47 C 45.14152145385742 47 47 45.14152145385742 47 42.85713958740234 L 47 7.142860412597656 C 47 4.858478546142578 45.14152145385742 3 42.85713958740234 3 L 7.142860412597656 3 M 7.142860412597656 0 L 42.85713958740234 0 C 46.80204010009766 0 50 3.197971343994141 50 7.142860412597656 L 50 42.85713958740234 C 50 46.80204010009766 46.80204010009766 50 42.85713958740234 50 L 7.142860412597656 50 C 3.197971343994141 50 0 46.80204010009766 0 42.85713958740234 L 0 7.142860412597656 C 0 3.197971343994141 3.197971343994141 0 7.142860412597656 0 Z",
    stroke: "none",
    fill: "#6a767d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(507.857 713.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M3851.521,1845.654l13.81-13.309a2.1,2.1,0,0,0,0-3.045h0a2.294,2.294,0,0,0-3.159,0l-13.81,13.309a2.1,2.1,0,0,0,0,3.046h0A2.294,2.294,0,0,0,3851.521,1845.654Z",
    transform: "translate(-3840.271 -1828.669)",
    fill: "#6a767d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M3822.259,1859.993l-7.436-7.436a1.978,1.978,0,0,0-2.8,0h0a1.978,1.978,0,0,0,0,2.8l7.436,7.435a1.976,1.976,0,0,0,2.8,0h0A1.977,1.977,0,0,0,3822.259,1859.993Z",
    transform: "translate(-3811.449 -1845.752)",
    fill: "#6a767d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProceso);
export default __webpack_public_path__ + "static/media/ico_proceso.d9dba66250c3c742d97b408e642d8d49.svg";
export { ForwardRef as ReactComponent };